import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getSupplierByWarehouseIdApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getSupplierByWarehouseId = createAsyncThunk('getSupplierByWarehouseId', async (payload) => {
  // console.log('payload', payload);
  return await getSupplierByWarehouseIdApi(payload);
});

const getSupplierByWarehouseIdSlice = createSlice({
  name: 'getSupplierByWarehouseId', // Unique Name
  initialState,
  reducers: {
    getSupplierByWarehouseIdReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSupplierByWarehouseId.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getSupplierByWarehouseId.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getSupplierByWarehouseId.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getSupplierByWarehouseIdReset } = getSupplierByWarehouseIdSlice.actions;

export default getSupplierByWarehouseIdSlice.reducer;
